var ValueType = /* @__PURE__ */ function(ValueType2) {
  ValueType2["JSON"] = "json";
  ValueType2["BINARY"] = "binary";
  ValueType2["BASE64"] = "base64";
  return ValueType2;
}({});

export { ValueType };
//# sourceMappingURL=types.js.map
